<template>
    <!DOCTYPE html>
    <html lang="en">
        <head>
            <meta charset="UTF-8" />
            <link
                rel="stylesheet"
                href="https://cdn.jsdelivr.net/npm/instantsearch.css@8.1.0/themes/reset-min.css"
                integrity="sha256-2AeJLzExpZvqLUxMfcs+4DWcMwNfpnjUeAAvEtPr0wU="
                crossorigin="anonymous" />
        </head>
    </html>
    <return-button class="return-button" />
    <div
        class="mainContainer"
        no-gutters
        :class="{ 'is-loading-cursor': isLoading }">
        <div class="left-column">
            <div class="main-subcontainer">
                <div class="title-header">
                    <h1 class="title">Datos generales del paciente</h1>
                </div>
                <div class="content-container">
                    <v-row
                        v-if="!Object.keys(this.itemsPatient).length == 0"
                        justify="space-around">
                        <v-col cols="12" md="4">
                            <span class="indicator">Nombre:</span>
                            <span class="indicator-value">
                                {{ itemsPatient.nombre }}
                            </span>
                        </v-col>
                        <v-col cols="12" md="4">
                            <span class="indicator">Primer apellido:</span>
                            <span class="indicator-value">
                                {{ itemsPatient.primerApellido }}
                            </span>
                        </v-col>
                        <v-col cols="12" md="4">
                            <span class="indicator">Segundo apellido:</span>
                            <span class="indicator-value">
                                {{ itemsPatient.segundoApellido ?? null }}
                            </span>
                        </v-col>

                        <v-col cols="12" md="4">
                            <span class="indicator">Fecha de nacimiento:</span>
                            <span class="indicator-value">
                                {{ itemsPatient.birthdate }}
                            </span>
                        </v-col>
                        <v-col cols="12" md="4">
                            <span class="indicator">Edad:</span>
                            <span class="indicator-value">
                                {{ itemsPatient.edad }}
                            </span>
                        </v-col>
                        <v-col cols="12" md="4">
                            <span class="indicator">Peso:</span>
                            <span class="indicator-value">
                                {{ itemsPatient.peso }}
                                <span v-if="itemsPatient.peso">kg</span>
                            </span>
                        </v-col>
                        <v-col cols="12" md="4">
                            <span class="indicator">Estatura:</span>
                            <span class="indicator-value">
                                {{ itemsPatient.estatura }}
                                <span v-if="itemsPatient.estatura">cm</span>
                            </span>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div class="main-subcontainer">
                <div class="title-header">
                    <h1 class="title">Medicamento(s) a recetar</h1>
                </div>
                <div class="content-container">
                    <v-row>
                        <v-col
                            cols="12"
                            md="9"
                            v-click-outside="() => (showResults = false)">
                            <div class="search-inputs d-flex">
                                <ais-instant-search
                                    :search-client="searchClient"
                                    index-name="recetas"
                                    class="position-relative w-100">
                                    <ais-search-box
                                        ref="searchBox"
                                        id="mySearchBox"
                                        placeholder="Buscar medicamento"
                                        v-model="searchQuery"
                                        @input="handleSearchInput"
                                        @click="handleSearchBoxClick"
                                        :searchAsYouType="
                                            !prescriptionOpenInput.name
                                        "
                                        :class-names="{
                                            'ais-SearchBox-form':
                                                'MySearchBoxForm ',
                                            'ais-SearchBox-input':
                                                'MySearchBoxInput',
                                            'ais-SearchBox-submit':
                                                'MySearchBoxSubmit',
                                            'ais-SearchBox-reset':
                                                'MySearchBoxReset',
                                            'ais-SearchBox-resetIcon':
                                                'MySearchBoxResetIcon',
                                        }">
                                    </ais-search-box>
                                    <div
                                        class="columns-container position-relative">
                                        <ais-index index-name="recetasMarca">
                                            <ais-configure
                                                :restrictSearchableAttributes="[
                                                    'marca',
                                                    'descripcion',
                                                ]" />
                                            <div
                                                v-show="showResults"
                                                class="column-search position-absolute"
                                                style="left: 0; width: 50%">
                                                <!-- Posición absoluta izquierda -->
                                                <h3>Resultados por Marca</h3>
                                                <ais-hits
                                                    id="hits"
                                                    :class-names="{
                                                        'ais-Hits':
                                                            'MyHits position-absolute w-100 shadow',
                                                        'ais-Hits-list':
                                                            'MyHitsList',
                                                        'ais-Hits-item':
                                                            'MyHitsItem',
                                                    }">
                                                    <template
                                                        v-slot:item="{ item }">
                                                        <div
                                                            @click="
                                                                () =>
                                                                    handleItemClick(
                                                                        item,
                                                                    )
                                                            "
                                                            class="hit-item p-2"
                                                            style="
                                                                cursor: pointer;
                                                            ">
                                                            <h5>
                                                                Marca:
                                                                <ais-highlight
                                                                    :hit="item"
                                                                    attribute="marca" />
                                                            </h5>
                                                            <h5>
                                                                Sal:
                                                                <ais-highlight
                                                                    :hit="item"
                                                                    attribute="descripcion" />
                                                            </h5>
                                                            <h5>
                                                                Presentacion:
                                                                <ais-highlight
                                                                    :hit="item"
                                                                    attribute="presentacion" />
                                                            </h5>
                                                        </div>
                                                    </template>
                                                </ais-hits>
                                            </div>
                                        </ais-index>

                                        <!-- Columna Derecha: Búsqueda solo en 'descripcion' -->
                                        <ais-index index-name="recetasSal">
                                            <ais-configure
                                                :restrictSearchableAttributes="[
                                                    'descripcion',
                                                ]" />
                                            <div
                                                v-show="showResults"
                                                class="column-search position-absolute"
                                                style="right: 0; width: 50%">
                                                <!-- Posición absoluta derecha -->
                                                <h3>Resultados por Sal</h3>
                                                <ais-hits
                                                    id="hits"
                                                    :class-names="{
                                                        'ais-Hits':
                                                            'MyHits position-absolute w-100 shadow',
                                                        'ais-Hits-list':
                                                            'MyHitsList',
                                                        'ais-Hits-item':
                                                            'MyHitsItem',
                                                    }">
                                                    <template
                                                        v-slot:item="{ item }">
                                                        <div
                                                            @click="
                                                                () =>
                                                                    handleItemClick(
                                                                        item,
                                                                    )
                                                            "
                                                            class="hit-item p-2"
                                                            style="
                                                                cursor: pointer;
                                                            ">
                                                            <h5>
                                                                Sal:
                                                                <ais-highlight
                                                                    :hit="item"
                                                                    attribute="descripcion" />
                                                            </h5>
                                                            <h5>
                                                                Presentacion:
                                                                <ais-highlight
                                                                    :hit="item"
                                                                    attribute="presentacion" />
                                                            </h5>
                                                        </div>
                                                    </template>
                                                </ais-hits>
                                            </div>
                                        </ais-index>
                                    </div>
                                </ais-instant-search>
                            </div>
                        </v-col>
                        <v-col
                            cols="12"
                            md="3"
                            class="d-flex align-center justify-center">
                            <v-checkbox
                                style="font-family: var(--font-body)"
                                v-model="searchMedication"
                                label="Escribir medicamento no catalogado"
                                color="#4CABD3"
                                hide-details />
                        </v-col>
                    </v-row>
                    <!-- Matriz -->
                    <MedicationMatrix
                        v-if="matching_medication.length > 0"
                        :medications="matching_medication"
                        :presentations="medication_presentations"
                        :medicationData="medicationData"
                        :selected_medication="selectedSearchHit"
                        :locations="distanceLocations"
                        :locationId="itemsPractitioner?.location"
                        @select-medication="handleMatrixClick"
                        @order-by-presentation-price="
                            handleOrderByPresentationPrice
                        " />
                    <div
                        class="no-medication"
                        v-if="
                            searchCompleted && matching_medication.length <= 0
                        ">
                        <p>
                            No se encontraron existencias del medicamento
                            buscado en esta sucursal. Prueba a cambiar de
                            sucursal, o selecciona otro medicamento.
                        </p>
                    </div>
                    <!-- Espacio para los inputs de informacion -->
                    <v-row style="margin-top: 15px">
                        <v-col cols="12" v-if="isControlled">
                            <div style="color: #d32f2f; font-family: var(--font-body); font-size: 14px; font-weight: 500;">
                                Este medicamento requiere que escriba manualmente las indicaciones
                            </div>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <v-text-field
                                class="field-input"
                                hide-details="auto"
                                variant="outlined"
                                v-model="pack_product.frequency"
                                persistent-placeholder
                                placeholder=" "
                                :rules="rules.frequency"
                                :disabled="!selectedItem || isControlled"
                                :min="1">
                                <template #label>
                                    <span class="field-label"> Dosis </span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <v-select
                                class="field-input"
                                hide-details="auto"
                                variant="outlined"
                                v-model="pack_product.form"
                                :items="items_tipo_presentacion"
                                :disabled="!selectedItem || isControlled"
                                outlined>
                                <template #label>
                                    <span class="field-label">
                                        Presentación
                                    </span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <v-text-field
                                class="field-input"
                                persistent-placeholder
                                placeholder=" "
                                hide-details="auto"
                                variant="outlined"
                                v-model="pack_product.period_time"
                                label="Cada"
                                :rules="rules.number_time"
                                :disabled="!selectedItem || isControlled"
                                :min="1">
                                <template #label>
                                    <span class="field-label"> Cada </span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <v-select
                                class="field-input"
                                hide-details="auto"
                                variant="outlined"
                                v-model="pack_product.type_period_time"
                                :items="items_rango_tiempo"
                                :disabled="!selectedItem || isControlled"
                                outlined>
                                <template #label>
                                    <span class="field-label">
                                        Frecuencia
                                    </span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <v-text-field
                                class="field-input"
                                persistent-placeholder
                                placeholder=" "
                                hide-details="auto"
                                variant="outlined"
                                v-model="pack_product.duration_time"
                                label="Durante"
                                :rules="rules.number_time"
                                :disabled="!selectedItem || isControlled"
                                :min="1">
                                <template #label>
                                    <span class="field-label"> Durante </span>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <v-select
                                class="field-input"
                                hide-details="auto"
                                variant="outlined"
                                v-model="pack_product.type_duration_time"
                                :items="items_tiempo"
                                :disabled="!selectedItem || isControlled"
                                outlined>
                                <template #label>
                                    <span class="field-label"> Tiempo </span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <v-select
                                class="field-input"
                                hide-details="auto"
                                variant="outlined"
                                v-model="pack_product.route"
                                :items="items_tipo_administracion"
                                :disabled="!selectedItem || isControlled"
                                outlined>
                                <template #label>
                                    <span class="field-label">
                                        Vía de admin.
                                    </span>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <v-text-field
                                class="field-input"
                                persistent-placeholder
                                placeholder=" "
                                hide-details="auto"
                                variant="outlined"
                                v-model="pack_product.box_quantity"
                                label="Piezas"
                                :rules="rules.number_time"
                                :disabled="!selectedItem || isControlled"
                                :min="1">
                                <template #label>
                                    <span class="field-label">
                                        Tratamiento total
                                    </span>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-textarea
                                class="field-input"
                                persistent-placeholder
                                placeholder=" "
                                rows="3"
                                hide-details="auto"
                                variant="outlined"
                                maxlength="500"
                                v-model="pack_product.note"
                                label="Indicaciones"
                                :disabled="!selectedItem"
                                outlined>
                                <template #label>
                                    <span class="field-label">
                                        Indicaciones especiales del medicamento
                                    </span>
                                </template>
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <div class="d-flex justify-end">
                        <v-btn
                            class="return-btn"
                            @click="add_product"
                            style="text-transform: none"
                            :disabled="medication_check">
                            <v-icon class="field-icon">mdi mdi-pill</v-icon>
                            Añadir a receta
                        </v-btn>
                    </div>
                    <div
                        style="min-height: 80px; min-width: 100%"
                        class="custom-field field-input">
                        <label class="custom-label field-label">
                            Medicamento agregado a receta
                        </label>
                        <div class="custom-box">
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    gap: 10px;
                                ">
                                <p style="font-size: 14px" v-if="selectedItem">
                                    Medicamento:
                                    <span v-if="this.selectPatente == true">
                                        {{ selectedItem.art_marca }},
                                    </span>
                                    {{ selectedItem.art_des }}
                                </p>
                                <p
                                    style="font-size: 14px"
                                    v-if="
                                        pack_product.frequency &&
                                        pack_product.form &&
                                        pack_product.period_time &&
                                        pack_product.type_period_time &&
                                        pack_product.duration_time &&
                                        pack_product.type_duration_time &&
                                        pack_product.route
                                    ">
                                    {{ setPatientInstruction(pack_product) }}.
                                    <span
                                        v-if="
                                            !pack_product.note &&
                                            pack_product.box_quantity
                                        "
                                        >(
                                        {{ pack_product.box_quantity }}
                                        Piezas )
                                    </span>
                                </p>
                                <p
                                    v-if="pack_product.note"
                                    style="font-size: 14px"
                                    class="preview-limits">
                                    {{ pack_product.note }}.
                                    <span
                                        style="font-size: 14px"
                                        v-if="pack_product.box_quantity">
                                        (
                                        {{ pack_product.box_quantity }}
                                        Piezas )
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-subcontainer">
                <div class="title-header">
                    <h1 class="title">Notas</h1>
                </div>
                <div class="content-container">
                    <v-textarea
                        class="field-input"
                        persistent-placeholder
                        placeholder=" "
                        rows="4"
                        hide-details="auto"
                        variant="outlined"
                        maxlength="500"
                        v-model="general_note">
                        <template #label>
                            <span class="field-label"> Nota </span>
                        </template>
                    </v-textarea>
                </div>
            </div>
        </div>
        <div class="right-column">
            <div class="Recetacontenedor-size" style="position: relative">
                <v-container>
                    <RecetaContenedor
                        v-bind="prescriptionProps"
                        @deletePrescription="remove_product"
                        @editPrescription="edit_product" />
                </v-container>
            </div>
            <div
                class="d-flex justify-end"
                style="position: fixed; bottom: 30px; right: 30px; z-index: 100;">
                <v-btn
                    color="#4CABD3"
                    size="large"
                    class="text-white"
                    style="font-family: var(--font-body);"
                    @click="dialog = true"
                    >Recetar</v-btn
                >
            </div>
        </div>
        <div class="d-flex justify-end mr-16 text-center">
            <v-dialog v-model="dialog" persistent>
                <v-row justify="center">
                    <v-card class="h-50 min-w-25">
                        <i
                            class="mdi mdi-close-circle boton-cerrar-x"
                            style="
                                position: absolute;
                                top: 10px;
                                right: 10px;
                                float: right;
                                font-size: 25px;
                                cursor: pointer;
                                color: white;
                            "
                            @click="dialog = false"></i>
                        <v-card-title> Crear Receta </v-card-title>
                        <v-card-text
                            class="text-center"
                            style="
                                font-size: 16px;
                                margin-top: 10px;
                                font-family: var(--font-body);
                            ">
                            {{ confirmationMessage }}
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn color="#4CABD3" @click="enviar_receta"
                                >Crear Receta</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-row>
            </v-dialog>
            <alertMessage ref="alertRef"></alertMessage>
        </div>
        <v-dialog v-model="searchMedication" persistent>
            <v-row justify="center">
                <v-card class="h-70 min-w-50">
                    <i
                        class="mdi mdi-close-circle boton-cerrar-x"
                        style="
                            position: absolute;
                            top: 10px;
                            right: 10px;
                            float: right;
                            font-size: 25px;
                            cursor: pointer;
                            color: white;
                        "
                        @click="searchMedication = false"></i>
                    <v-card-title> Nuevo Medicamento </v-card-title>
                    <div class="modal-content">
                        <div class="form-group">
                            <v-text-field
                                hide-details="auto"
                                variant="outlined"
                                v-model="prescriptionOpenInput.name"
                                @input="
                                    prescriptionOpenInput.name = validarFormato(
                                        $event.target.value,
                                    )
                                "
                                label="Sal"
                                outlined></v-text-field>
                        </div>
                        <div class="form-group">
                            <v-text-field
                                hide-details="auto"
                                variant="outlined"
                                v-model="prescriptionOpenInput.presentation"
                                @input="
                                    prescriptionOpenInput.presentation =
                                        validarFormato($event.target.value)
                                "
                                label="Presentacion"
                                outlined></v-text-field>
                        </div>
                        <div class="form-group">
                            <v-text-field
                                hide-details="auto"
                                variant="outlined"
                                v-model="prescriptionOpenInput.dosage"
                                @input="
                                    prescriptionOpenInput.dosage =
                                        validarFormato($event.target.value)
                                "
                                label="Contenido"
                                outlined></v-text-field>
                        </div>
                        <p style="font-size: 14px" v-if="prescriptionOpenInput">
                            Medicamento:
                        </p>
                        <p>
                            <span v-if="prescriptionOpenInput.brand">
                                {{ prescriptionOpenInput.brand }},
                            </span>
                            {{ prescriptionOpenInput.name }}
                            {{ prescriptionOpenInput.presentation }}
                            {{ prescriptionOpenInput.dosage }}
                        </p>
                    </div>
                    <v-card-actions class="justify-center">
                        <v-btn
                            color="#6c757d"
                            @click="searchMedication = false">
                            Cancelar
                        </v-btn>
                        <v-btn
                            class="v-btn"
                            color="#4CABD3"
                            :disabled="
                                !prescriptionOpenInput.brand &&
                                !prescriptionOpenInput.name
                            "
                            @click="addPresentation"
                            v-bind="props">
                            Agregar Medicamento
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-row>
        </v-dialog>
    </div>
</template>
<script type="module">
import returnButton from '@/components/global/return-button.vue';
import alertMessage from '@/components/global/alert-message.vue';
import { getPatientById } from '@/api/pacientes';
import { getMedicamentos } from '@/api/medicamentos';
import { getPractitioner } from '@/api/practicante';
import {
    getAllLocationsByDistance,
    getLocationReference,
    getAllLocations,
} from '@/api/location';
import { postRecetas, getRecetas } from '@/api/recetas';
import { getFinalNote } from '@/api/notas';
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import MedicationMatrix from '@/components/global/medication-matrix.vue';
import RecetaContenedor from '@/components/global/receta-layout.vue';
import { reactive } from 'vue';
import { printCustomPdf, isControlledMed } from '@/utils/printPdf';

export default {
    components: {
        returnButton,
        MedicationMatrix,
        RecetaContenedor,
        alertMessage,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        const reglasComunes = {
            requerido: (v) => !!v || 'Este campo es obligatorio.',
            frecuency_format: (v) =>
                /^(?:\d+\.?\d*|\.\d+)$/.test(v) || 'Formato de número inválido',
            time_format: (v) =>
                /^[1-9]\d*$/.test(v) || 'Formato de número inválido',
            opcional: (regla) => (v) => !v || regla(v), // Función para campos opcionales
        };
        return {
            confirmationMessage: 'Favor de revisar su receta antes de crearla.',
            itemsPatient: [],
            isLoading: false,
            diagnosticSelected: '',
            searchClient: instantMeiliSearch(
                process.env.VUE_APP_MEILI_SEARCH_URL,
                process.env.VUE_APP_MEILI_SEARCH_KEY,
            ).searchClient,
            defaultField: 'marca',
            meilisearchParam: [
                { text: 'Marca', value: 'marca' },
                { text: 'Sal', value: 'descripcion' },
            ],
            searchQuery: '',
            showResults: false,
            itemsPractitioner: null,
            controlled_medications_locations: [],
            non_controlled_medications_locations: [],
            locations: [],
            distanceLocations: [],
            selectedLocation: '',
            accept_blank_prescription: false,
            selectedSearchHit: '',
            searchCompleted: '',
            sortedPresentation: '',
            sortedAscending: true,
            matching_medication: [],
            practitionerLocation: [],
            selectPatente: false,
            selectedItem: null,
            pack_product: {
                frequency: '',
                form: '',
                period_time: '',
                type_period_time: '',
                duration_time: '',
                type_duration_time: '',
                route: '',
                note: '',
                box_quantity: '',
            },
            general_note: '',
            items_tipo_presentacion: [
                'Tableta(s)',
                'Capsula(s)',
                'Ml',
                'Gr',
                'Gota(s)',
                'Ampolleta(s)',
                'Disparo(s)',
                'Ovulo(s)',
                'Tableta efervescente',
                'Capa ligera',
                'Capa abundante',
                'Parche(s)',
                'Supositorio(s)',
                'Enema',
                'Sobres',
                'Gasas',
                'Otro',
            ],
            items_tipo_administracion: [
                'Oral',
                'Nasal',
                'Inhalación',
                'Oftálmica',
                'Intramuscular',
                'Intravenosa',
                'Intradérmica',
                'Ótica',
                'Sublingual',
                'Tópica',
                'Cutánea',
                'Subcutánea',
                'Transdérmica',
                'Rectal',
                'Vaginal',
                'Orodispersable',
                'Nebulización',
            ],
            items_tiempo: ['Día(s)', 'Semana(s)', 'Mes(es)', 'Año(s)'],
            items_rango_tiempo: ['Hora(s)', 'Día(s)', 'Semana(s)', 'Mes(es)'],
            prescriptions: [],
            snackbar: false,
            snackbarText: '',
            dialog: false,
            rules: {
                frequency: [
                    reglasComunes.opcional(reglasComunes.frecuency_format),
                ],
                number_time: [
                    reglasComunes.opcional(reglasComunes.time_format),
                ],
                requerido: (value) => !!value || 'Requerido',
                empleado: (value) => {
                    const pattern = /^\d+$/;
                    return pattern.test(value) || 'Inválido';
                },
                durante: (value) => {
                    const pattern = /^\d+$/;
                    return pattern.test(value) || 'Inválido';
                },
            },
            recetas: [],
            searchMedication: false,
            prescriptionOpenInput: {
                brand: '',
                name: '',
                presentation: '',
                dosage: '',
            },
            prescriptionOpenStatus: false,
            appointmentId: '',
            allPrescription: [],
            recipeId: '',
            recetaData: null,
            itemNote: null,
        };
    },
    created() {
        this.appointmentId = sessionStorage.getItem('tempAppointmentId');
        this.fetchPatient();
        this.fetchPractitioner();
        this.fetchLocations();
    },
    watch: {
        updateBoxQuantity(newVal) {
            this.pack_product.box_quantity = isNaN(newVal) ? '' : newVal;
        },
        'prescriptionOpenInput.name': {
            handler(newVal) {
                if (newVal) {
                    let displayText = newVal;
                    if (this.prescriptionOpenInput.presentation) {
                        displayText +=
                            ' ' + this.prescriptionOpenInput.presentation;
                    }
                    if (this.prescriptionOpenInput.dosage) {
                        displayText += ' ' + this.prescriptionOpenInput.dosage;
                    }
                    this.searchQuery = displayText;
                    this.showResults = false;
                }
            },
            immediate: true,
        },
    },
    beforeUnmount() {
        document.body.classList.remove('is-loading-cursor');
    },
    methods: {
        fetchLocations() {
            getAllLocations()
                .then((response) => {
                    this.locations = response;
                })
                .catch((error) => {
                    console.error('Error fetching locations:', error);
                });
        },
        fetchPatient() {
            getPatientById(this.id) // id del props
                .then((itemsPatient) => {
                    this.itemsPatient = itemsPatient;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        handleSearchInput() {
            if (this.prescriptionOpenInput.name) {
                this.showResults = false;
                return;
            }
            this.showResults = this.searchQuery !== '';
            if (this.searchQuery === '') {
                this.selectedItem = null;
                this.matching_medication = [];
            }
            this.resetForm();
        },

        handleSearchBoxClick() {
            if (this.prescriptionOpenInput.name) {
                // Resetear el estado del medicamento libre
                this.prescriptionOpenInput = {
                    brand: '',
                    name: '',
                    presentation: '',
                    dosage: '',
                };
                this.prescriptionOpenStatus = false;

                // Limpiar la búsqueda y permitir buscar de nuevo
                this.searchQuery = '';
                this.selectedItem = null;
                this.matching_medication = [];
                this.showResults = false;

                // Enfocar el campo de búsqueda
                this.$nextTick(() => {
                    const searchInput =
                        document.querySelector('.MySearchBoxInput');
                    if (searchInput) {
                        searchInput.focus();
                    }
                });
            }
        },
        async handleItemClick(item) {
            if (this.isLoading) return;
            // hacemos un debounce por si el usuario hace doble click para evitar hacer varias consultas
            this.isLoading = true;
            // Esto es para que el usuario sienta que se esta procesando algo, haciendo que se sienta mas veloz.
            document.documentElement.classList.add('is-loading-cursor');

            void document.documentElement.offsetHeight;
            await new Promise((resolve) => setTimeout(resolve, 50));
            try {
                await new Promise((resolve) => requestAnimationFrame(resolve));

                this.selectedSearchHit = item;
                this.searchCompleted = true;

                // ==========================================
                // Logs de depuración (comentados para mantener limpia la consola)
                // Sirven para verificar qué datos llegan crudos desde el buscador cuando 
                // seleccionas un medicamento, y para confirmar la sucursal del médico.
                // console.log('item:', item);
                // console.log('descripcion2:', item.descripcion2);
                // console.log('itemsPractitioner:', this.itemsPractitioner);
                // console.log('location:', this.itemsPractitioner?.location);
                // ==========================================

                const descrip = item.descripcion2 || item.descripcion || '';
                const results = await getMedicamentos(
                    descrip,
                    this.itemsPractitioner?.location,
                );

                if (!results || !results.data) {
                    this.matching_medication = [];
                    this.medication_presentations = [];
                    this.all_medications = [];
                    this.medicationData = null;
                } else {
                    this.matching_medication = results.data.grouped_medications;
                    this.medication_presentations = results.data.all_presentations; //rev
                    this.all_medications = results.data.medications; //rev
                    this.medicationData = results.data;
                }

                this.searchQuery =
                    (this.selectedSearchHit.marca ? this.selectedSearchHit.marca + ',' : '') +
                    this.selectedSearchHit.descripcion;

                // Asegura que la actualización del estado se refleje en el DOM
                this.$nextTick(() => {
                    this.showResults = false;
                });
            } catch (error) {
                console.error('Error buscando medicamento:', error);
            } finally {
                this.isLoading = false;
                document.documentElement.classList.remove('is-loading-cursor');
            }
        },
        fetchPractitioner() {
            let id_med = localStorage.getItem('id-user');

            if (!id_med) {
                console.error(
                    'ID del practicante no encontrado en localStorage',
                );
                return;
            }

            getPractitioner(id_med)
                .then((response) => {
                    // ==========================================
                    // Logs de depuración (comentados para mantener limpia la consola)
                    // Sirven para inspeccionar la respuesta completa del backend con 
                    // los datos del médico (practitioner) y confirmar su ID de sucursal (location).
                    // console.log('RESPUESTA getPractitioner:', response);
                    // console.log('RESPUESTA getPractitioner JSON:', JSON.parse(JSON.stringify(response)));
                    // console.log('LOCATION DEL PRACTITIONER:', response?.location);
                    // ==========================================
                    this.itemsPractitioner = response;
                    this.getLocations();
                })
                .catch((error) => {
                    console.error(
                        'Error al obtener los datos del médico: ',
                        error,
                    );
                });
        },
        getLocations() {
            getAllLocationsByDistance(this.itemsPractitioner.location)
                .then((response) => {
                    this.distanceLocations = response;
                    const locations = response;
                    const controlledLocations = [];
                    const nonControlledLocations = [];

                    locations.forEach((location) => {
                        if (location.vende_controlados) {
                            controlledLocations.push(location);
                        } else {
                            nonControlledLocations.push(location);
                        }
                    });

                    this.controlled_medications_locations = controlledLocations;
                    this.non_controlled_medications_locations =
                        nonControlledLocations;
                    this.selectedLocation = locations[0].sucursal;
                })
                .catch((error) => {
                    console.error('Error al obtener las sucursales: ', error);
                });
            getLocationReference(this.itemsPractitioner.location)
                .then((response) => {
                    this.practitionerLocation = response.location;
                })
                .catch((error) => {
                    console.error('Error al obtener las sucursales: ', error);
                });
        },
        handleMatrixClick(medication_id) {
            this.selectedItem = this.all_medications.find((medication) => {
                if (Array.isArray(medication.art_barcod)) {
                    return medication.art_barcod.includes(medication_id);
                } else {
                    return medication.art_barcod === medication_id;
                }
            });
            if (this.selectedItem.art_tipo == 'PATENTE') {
                this.selectPatente = true;
            } else {
                this.selectPatente = false;
            }
        },
        handleOrderByPresentationPrice(presentation) {
            if (this.sortedPresentation === presentation) {
                this.sortedAscending = !this.sortedAscending;
            } else {
                this.sortedPresentation = presentation;
                this.sortedAscending = true;
            }

            this.matching_medication.sort((a, b) => {
                const priceA =
                    a.presentations.find((p) => p.name === presentation)
                        ?.price || 0;
                const priceB =
                    b.presentations.find((p) => p.name === presentation)
                        ?.price || 0;
                return this.sortedAscending ? priceA - priceB : priceB - priceA;
            });
        },
        addPresentation() {
            const openPrescription = {
                art_marca: this.prescriptionOpenInput.brand,
                art_des:
                    this.prescriptionOpenInput.name +
                    ' ' +
                    this.prescriptionOpenInput.presentation +
                    ' ' +
                    this.prescriptionOpenInput.dosage,
                art_tipo: null,
                art_barcod: null,
                art_grupo: null,
                art_cant: this.prescriptionOpenInput.dosage,
            };

            this.selectedItem = openPrescription;
            this.prescriptionOpenStatus = true;
            this.searchMedication = false;
            this.searchCompleted = '';
            this.matching_medication = [];
            this.selectedSearchHit = '';
            this.selectPatente = false;
        },
        setPatientInstruction(packProduct) {
            const unitMap = {
                'Año(s)': ['Año', 'Años'],
                'Mes(es)': ['Mes', 'Meses'],
                'Semana(s)': ['Semana', 'Semanas'],
                'Día(s)': ['Día', 'Días'],
                'Hora(s)': ['Hora', 'Horas'],
            };
            const administrationForm = {
                Oral: 'Tomar',
                Nasal: 'Aplicar',
                Inhalación: 'Aplicar',
                Oftálmica: 'Aplicar',
                Intramuscular: 'Inyectar',
                Ótica: 'Aplicar',
                Sublingual: 'Colocar',
                Tópica: 'Aplicar',
                Cutánea: 'Aplicar',
                Subcutánea: 'Aplicar',
                Transdérmica: 'Aplicar',
                Rectal: 'Insertar',
                Vaginal: 'Aplicar',
                Orodispersable: 'Tomar',
                nebulizacion: 'Inhalar',
            };

            const finalPeriodDuraton =
                packProduct.period_time == 1
                    ? packProduct.period_time +
                      ' ' +
                      unitMap[packProduct.type_period_time][0]
                    : packProduct.period_time +
                      ' ' +
                      unitMap[packProduct.type_period_time][1];
            const finalBoundsDuration =
                packProduct.duration_time == 1
                    ? packProduct.duration_time +
                      ' ' +
                      unitMap[packProduct.type_duration_time][0]
                    : packProduct.duration_time +
                      ' ' +
                      unitMap[packProduct.type_duration_time][1];

            const patientInstruction =
                administrationForm[packProduct.route] +
                ' ' +
                packProduct.frequency +
                ' ' +
                packProduct.form +
                ' cada ' +
                finalPeriodDuraton +
                ' durante ' +
                finalBoundsDuration +
                ',' +
                ' Vía ' +
                packProduct.route;

            return patientInstruction;
        },
        handleLocationChange(event) {
            this.itemsPractitioner.location = event.target.value;
            // Se usa la funcion siguiente para realizar la busqueda por el cambio de sucursal
            if (this.searchCompleted) {
                this.handleItemClick(this.selectedSearchHit);
            }
        },
        sortMedicationsByBrand() {
            this.medications.sort((a, b) => {
                return a.brand.localeCompare(b.brand);
            });
        },
        isSortedBy(presentation) {
            return (
                this.sortedPresentation === presentation && this.sortedAscending
            );
        },
        /**
         * @param {string} text string Texto en el mensaje de error
         * @param {boolean} resetFields boolean Indica si se deben resetear los campos de los productos
         * @returns {void}
         */
        errorInFields(text, resetFields) {
            this.messageAlertSnackBar(text, 'error');
            if (resetFields) this.resetProductFields();
            return;
        },
        fieldsAreValid() {
            const isDuplicate = this.prescriptions.some(
                (item) => item.itemId === this.selectedItem.art_barcod,
            );

            if (isDuplicate) {
                this.errorInFields(
                    'Este medicamento ya ha sido añadido.',
                    true,
                );
                return false;
            }

            // Eliminado: La lógica de separar recetas con controlados ahora ocurre automáticamente en el backend.
            /*
            const isControlledDrug = parseInt(this.selectedItem.art_grupo) <= 3;
            const hasPrescriptions = this.prescriptions.length >= 1;
            const firstPrescriptionIsControlled =
                this.prescriptions[0]?.grupo <= 3;

            if (
                (isControlledDrug && hasPrescriptions) ||
                (hasPrescriptions && firstPrescriptionIsControlled)
            ) {
                this.errorInFields(
                    'Un medicamento controlado debe ir en su propia receta',
                    true,
                );
                return false;
            }
            */

            return true;
        },
        add_product() {
            this.searchCompleted = false;
            if (!this.fieldsAreValid()) {
                return;
            }

            const newProduct = {
                itemId: this.selectedItem.art_barcod,
                itemDescription: this.selectedItem.art_des,
                itemBrand: this.selectedItem.art_marca,
                itemType: this.selectedItem.art_tipo,
                itemGroup: parseInt(this.selectedItem.art_grupo, 10),
                productFrequency: this.pack_product.frequency,
                productDosageForm: this.pack_product.form,
                productPeriodTime: this.pack_product.period_time,
                productTypePeriodTime: this.pack_product.type_period_time,
                productDurationTime: this.pack_product.duration_time,
                productTypeDurationTime: this.pack_product.type_duration_time,
                productRoute: this.pack_product.route,
                productNote: this.pack_product.note,
                productBoxQuantity: this.pack_product.box_quantity,
                requireMarca: this.selectPatente,
                openStatus: this.prescriptionOpenStatus,
            };

            this.prescriptions.push(newProduct);
            this.prescriptions.sort((a, b) => {
                const aControlled = isControlledMed(a) ? 1 : 0;
                const bControlled = isControlledMed(b) ? 1 : 0;
                return bControlled - aControlled;
            });
            this.resetProductFields();
            this.resetForm();
        },
        resetProductFields() {
            this.matching_medication = [];
            (this.searchQuery = ''),
                (this.pack_product = {
                    frequency: '',
                    form: '',
                    period_time: '',
                    type_period_time: '',
                    duration_time: '',
                    type_duration_time: '',
                    route: '',
                    note: '',
                    box_quantity: '',
                });
            this.selectedSearchHit = '';
            this.selectPatente = false;
        },
        remove_product(index) {
            this.prescriptions.splice(index, 1);
        },
        edit_product(index) {
            this.resetProductFields();
            this.resetForm();

            const prescription = this.prescriptions[index];

            this.selectedItem = {
                ...this.selectedItem,
                art_barcod: prescription.itemId,
                art_des: prescription.itemDescription,
                art_marca: prescription.itemBrand,
                art_tipo: prescription.itemType,
                art_grupo: prescription.itemGroup,
            };

            this.pack_product = {
                ...this.pack_product,
                frequency: prescription.productFrequency,
                form: prescription.productDosageForm,
                period_time: prescription.productPeriodTime,
                type_period_time: prescription.productTypePeriodTime,
                duration_time: prescription.productDurationTime,
                type_duration_time: prescription.productTypeDurationTime,
                route: prescription.productRoute,
                note: prescription.productNote,
                box_quantity: prescription.productBoxQuantity,
            };

            this.selectPatente = prescription.requireMarca;
            this.prescriptionOpenStatus = prescription.openStatus;

            this.remove_product(index);
        },
        puede_enviar_receta() {
            const has_medications = this.prescriptions.length > 0;
            const has_general_note = this.general_note.trim() !== '';
            const has_accepted_blank_prescription =
                this.accept_blank_prescription;

            return (
                has_medications ||
                has_general_note ||
                has_accepted_blank_prescription
            );
        },
        async enviar_receta() {
            this.confirmationMessage =
                'Favor de revisar su receta antes de crearla.';

            if (!this.puede_enviar_receta()) {
                this.confirmationMessage =
                    'Esta receta esta vacia. ¿Estás seguro de que quieres crearla?';
                this.accept_blank_prescription = true;
                return;
            }
            let practitionerId = localStorage.getItem('id-user');

            const convertirUnidadTiempo = (unidad) => {
                const unidades = {
                    'Hora(s)': 'h',
                    'Día(s)': 'd',
                    'Semana(s)': 'w',
                    'Mes(es)': 'm',
                    'Año(s)': 'y',
                };
                return unidades[unidad] || unidad;
            };

            const prescription = this.prescriptions.map((receta) => {
                return {
                    medicationBarcod: receta.itemId,
                    medicationQuantity: receta.productBoxQuantity,
                    medicationDescription: receta.itemDescription,
                    medicationBrand: receta.itemBrand,
                    dosage: [
                        {
                            frequency: receta.productFrequency,
                            periodUnit: receta.productPeriodTime,
                            periodDuration: convertirUnidadTiempo(
                                receta.productTypePeriodTime,
                            ),
                            boundsUnit: receta.productDurationTime,
                            boundsDuration: convertirUnidadTiempo(
                                receta.productTypeDurationTime,
                            ),
                            dosageForm: receta.productDosageForm,
                        },
                    ],
                    medicationRoute: receta.productRoute,
                    medicationNote: receta.productNote,
                    statusOpenPrescription: receta.openStatus,
                };
            });

            const data = {
                subject: `patient_models/${this.id}`,
                requester: practitionerId,
                prescription: prescription,
                note: this.general_note,
                appointmentId: this.appointmentId,
                prescriptionUUID: crypto.randomUUID()
            };

            try {
                const response = await postRecetas(data);
                if (response.status === 200) {
                    localStorage.removeItem('searchParams');
                    localStorage.removeItem('searchResults');
                    
                    // Tomamos el UUID único de la receta
                    const identifierRecipe = Array.isArray(response.data) 
                        ? response.data[0].fhirModel.identifier[0].value 
                        : (response.data.data ? response.data.data[0].fhirModel.identifier[0].value : response.data.fhirModel.identifier[0].value);
                    
                    // Al descargar la receta, el backend devolverá todos los recursos asociados a ese UUID (las páginas separadas)
                    await this.fetchRecipeData(identifierRecipe);

                    this.$router.push({
                        name: 'Pacientes',
                        params: { id: this.id },
                        query: { notificacion: 'accion-completada' },
                    });
                    this.recetas = [];
                    this.prescriptions = [];
                    this.dialog = false;
                }
            } catch (error) {
                this.dialog = false;
                this.messageAlertSnackBar(error?.response?.data?.data || 'Error al guardar receta', 'error');
                console.error('Error al enviar la solicitud:', error);
            }
        },
        fetchRecipeData(identifierRecipe) {
            const convertirUnidadTiempo = (unidad) => {
                switch (unidad) {
                    case 'h':
                        return 'Hora(s)';
                    case 'd':
                        return 'Día(s)';
                    case 'w':
                        return 'Semana(s)';
                    case 'm':
                        return 'Mes(es)';
                    case 'y':
                        return 'Año(s)';
                    default:
                        return unidad;
                }
            };
            const capturedPrescriptions = [...this.prescriptions];
            const p1 = getRecetas(identifierRecipe)
                .then((data) => {
                    this.recipeId = data[0]?.identifier;
                    this.recetaData = data;
                    this.practitionerId = data[0]?.practitionerId;
                    this.fetchPractitioner();
                    this.practitionerIdValidation =
                        localStorage.getItem('id-user') == this.practitionerId;

                    // Si hay medicamentos en la receta, procesarlos (excluyendo el marcador 'Sin medicamentos')
                    this.recetaData.medicamentos = this.recetaData
                        .filter(
                            (med) =>
                                med.medicationReference?.display &&
                                med.medicationReference.display !==
                                    'Sin medicamentos',
                        )
                        .map((med, index) => {
                            med.unitDuration = convertirUnidadTiempo(
                                med.dosageInstruction?.timing?.repeat
                                    ?.boundsDuration?.unit || '',
                            );
                            med.period = convertirUnidadTiempo(
                                med.dosageInstruction?.timing?.repeat
                                    ?.periodUnit || '',
                            );
                            return {
                                recetaId: med.identifier,
                                itemDescription:
                                    med.medicationReference.display,
                                dosageInstruction:
                                    med.dosageInstruction?.text || '',
                                productBoxQuantity: med.medicationQuantity, //cantidad de cajas a surtir
                                productFrequency:
                                    med.dosageInstruction?.timing?.repeat
                                        ?.frequency || '',
                                productPeriodTime:
                                    med.dosageInstruction?.timing?.repeat
                                        ?.period || '',
                                productTypePeriodTime: med.period,
                                productDurationTime:
                                    med.dosageInstruction?.timing?.repeat
                                        ?.boundsDuration?.value || '',
                                productTypeDurationTime: med.unitDuration,
                                productRoute:
                                    med.dosageInstruction?.route?.text || '',
                                productNote: med.note,
                                itemBrand: med.marca,
                                category: med.category || (capturedPrescriptions[index]?.itemGroup <= 3 ? 'controlled' : 'normal'),
                            };
                        });
                    this.recetaData.medicamentos.sort((a, b) => {
                        const aControlled = isControlledMed(a) ? 1 : 0;
                        const bControlled = isControlledMed(b) ? 1 : 0;
                        return bControlled - aControlled;
                    });
                    const date = new Date(this.recetaData[0].authoredOn);
                    this.formDate(date);
                    this.onPrint();
                })
                .catch((error) => {
                    console.error('Error fetching recipe data:', error);
                });
            const p2 = getFinalNote(identifierRecipe)
                .then((finalNote) => {
                    this.itemNote = finalNote;
                })
                .catch((error) => {
                    console.log(error);
                });
            
            return Promise.all([p1, p2]);
        },
        onPrint() {
            printCustomPdf(
                this.recipeId,
                this.recetaData,
                this.prescriptionProps,
            );
        },
        formDate(ISOdate) {
            const date = new Date(ISOdate);
            return date.toLocaleDateString('es-ES', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        },
        messageAlertSnackBar(message, status) {
            const alertConfig = {
                message: message,
                type: status,
            };
            this.$refs.alertRef.show(alertConfig);
        },
        resetForm() {
            this.prescriptionOpenStatus = false;
            this.prescriptionOpenInput = {
                brand: '',
                name: '',
                presentation: '',
                dosage: '',
            };
        },
        validarFormato(valor) {
            return valor.toUpperCase().replace(/[^A-Z0-9%()/ .,]/g, '');
        },
    },
    computed: {
        isControlled() {
            return this.selectedItem && this.selectedItem.art_grupo !== null && parseInt(this.selectedItem.art_grupo) <= 3;
        },
        currentDate() {
            const date = new Date();
            const day = String(date.getDate()).padStart(2, '0'); // Asegura 2 dígitos
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses van de 0 a 11
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        updateBoxQuantity() {
            if (
                !(
                    this.pack_product.form == 'Capa abundante' ||
                    this.pack_product.form == 'Capa ligera'
                )
            ) {
                const convertToHours = (value, unit) => {
                    switch (unit) {
                        case 'Día(s)':
                            return value * 24;
                        case 'Semana(s)':
                            return value * 24 * 7;
                        case 'Mes(es)':
                            return value * 24 * 30;
                        case 'Año(s)':
                            return value * 24 * 365;
                        default:
                            return value; // Fallback to original value if unit not recognized
                    }
                };

                const hours = convertToHours(
                    this.pack_product.period_time,
                    this.pack_product.type_period_time,
                );
                const period_h = convertToHours(
                    this.pack_product.duration_time,
                    this.pack_product.type_duration_time,
                );

                const amount =
                    this.selectedItem && this.selectedItem.art_cant
                        ? this.selectedItem.art_cant
                        : 0;

                const baseCalculation =
                    amount !== 0 ? this.pack_product.frequency / amount : 0;

                const box = Math.ceil(
                    period_h > hours
                        ? (period_h / hours) * baseCalculation
                        : baseCalculation,
                );

                return box;
            } else {
                const box = '';
                return box;
            }
        },
        prescriptionProps() {
            return reactive({
                doctorName:
                    this.itemsPractitioner?.name?.length &&
                    this.itemsPractitioner?.lastname?.length
                        ? `${
                              this.itemsPractitioner?.prefix
                                  ? this.itemsPractitioner.prefix + ' '
                                  : ''
                          }${this.itemsPractitioner.name[0]} ${
                              this.itemsPractitioner.lastname[0]
                          }${
                              this.itemsPractitioner.lastname[1]
                                  ? ' ' + this.itemsPractitioner.lastname[1]
                                  : ''
                          }`
                        : '',
                doctorSpecialties: this.itemsPractitioner?.qualification
                    ? this.itemsPractitioner.qualification
                    : [],
                doctorZIPCode: this.itemsPractitioner?.postal_code || '',
                doctorAddress: this.practitionerLocation || [],
                doctorInformation: this.itemsPractitioner?.aditional_data
                    ? this.itemsPractitioner.aditional_data[0]
                    : '',
                doctorSignature: this.itemsPractitioner?.aditional_data
                    ? this.itemsPractitioner.aditional_data[1]
                    : '',
                doctorPhone: this.itemsPractitioner?.telecom
                    ? this.itemsPractitioner.telecom[0].value
                    : '',
                patientName:
                    this.itemsPatient.nombre && this.itemsPatient.primerApellido
                        ? `${this.itemsPatient.nombre} ${
                              this.itemsPatient.primerApellido
                          }${
                              this.itemsPatient.segundoApellido
                                  ? ` ${this.itemsPatient.segundoApellido}`
                                  : ''
                          }`
                        : '',
                patientAge: this.itemsPatient.edad,
                patientWeight: this.itemsPatient.peso || '',
                patientHeight: this.itemsPatient.estatura || '',
                prescriptions: this.prescriptions || [],
                finalNote: this.general_note,
                date: this.currentDate,
                isPrint: false,
            });
        },
        medication_check() {
            const p = this.pack_product;
            const regexFrequency = /^(?:\d+\.?\d*|\.\d+|\d+\/\d+)$/;
            const regexTime = /^[1-9]\d*(\.0+)?$/;

            if (this.isControlled) {
                return !this.selectedItem || !p.note;
            }

            return (
                !this.selectedItem ||
                !p.frequency ||
                !regexFrequency.test(p.frequency) ||
                !p.form ||
                !p.period_time ||
                p.period_time <= 0 ||
                !regexTime.test(p.period_time) ||
                !p.type_period_time ||
                !p.duration_time ||
                p.duration_time <= 0 ||
                !regexTime.test(p.duration_time) ||
                !p.type_duration_time ||
                !p.route
            );
        },
    },
};
</script>
<style scoped>
.MyHits {
    background-color: #f3f3f3;
    padding: 0.5rem;
    position: absolute;
    z-index: 100;
    width: 100%;
}

.MyHitsList {
    background-color: #f3f3f3;
    /* Fondo blanco */
}

.MyHitsItem {
    padding: 0.5rem;
    border: 1px solid #c2c2c2;
    border-top: none;
    border-radius: 1px;
}

.image-icon {
    width: 100px;
    height: 100px;
}

.contenedor {
    margin-top: 25px;
    background-color: white;
    border-radius: 10px;
    padding: 20px;
}

.main-inputs {
    border: solid 1px;
    border-radius: 10px;
    position: static;
    z-index: 0;
    padding: 14px;
    margin-top: 18px;
}

.datos-paciente {
    text-align: left;
    /* Alinea el contenido a la izquierda */
    margin-bottom: 10px;
    /* Agrega un margen inferior para separar del resto del contenido */
}

.found {
    font-weight: bold;
    text-decoration: none;
    color: #4caad3a1;
}

.selected-card {
    background-color: #ebebeb;
}

#location-selection::before {
    content: 'Selecciona una sucursal';
    color: #000000;
}
#location-selection {
    all: revert;
    margin-top: 10px;
    margin-bottom: 10px;
}

.no-medication {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    font-size: 20px;
    color: rebeccapurple;
}
.boton-cerrar-x {
    color: rgb(195, 14, 14);
    cursor: pointer;
    font-size: 30px;
    padding-bottom: 10px;
}
.boton-cerrar-x:hover {
    color: rgb(245, 115, 115);
}
.checkbox-padding {
    margin-bottom: -20px;
    margin-top: -6px;
}

.tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.tag {
    background-color: #e0e0e0;
    border-radius: 15px;
    padding: 5px 12px;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.delete-button {
    border: none;
    background: none;
    color: #666;
    margin-left: 8px;
    cursor: pointer;
    padding: 0;
    font-size: 16px;
    line-height: 1;
}

.delete-button:hover {
    color: #ff4444;
}

.mainContainer {
    display: flex;
    height: 83vh;
    gap: 0px;
}

.container {
    display: flex;
    height: 85vh;
    gap: 0px;
    padding: 2px;
}

.sub-container {
    margin: auto auto auto auto;
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-top: 1px;
    margin-bottom: 20px;
    padding: 20px;
    /* width: 90%; */
}

.Recetacontenedor-size {
    margin-left: 10px;
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    width: 580px;
    height: 815px;
    margin-top: 4px;
}

.left-column,
.right-column {
    padding-left: 15px;
    box-sizing: border-box;
}

.left-column {
    flex: 0 0 65%;
    overflow: auto;
    padding: 0px 10px;
}

.right-column {
    flex: 0 0 35%;
    overflow: auto;
}

.preview-limits {
    width: 100%;
    white-space: pre-wrap;
    overflow-wrap: break-word;
}

/* Media query para tablets y móviles */
@media screen and (max-width: 1100px) {
    .container {
        flex-direction: column;
        height: auto;
        min-height: 100vh;
    }

    .left-column,
    .right-column {
        flex: 1 1 auto;
        width: 100%;
        height: 100vh;
        min-height: 300px;
    }
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 500px;
}

.form-group {
    margin-bottom: 15px;
}

.modal-actions {
    margin-top: 20px;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

/* Mejorar apariencia de los resultados */
.MyHits {
    background: redwhite;
    max-height: 400px;
    overflow-y: auto;
    border-top: none;
    margin-left: -5px;
}

.MyHitsItem {
    padding: 12px;
    border-bottom: 1px solid #eee;
}

/* search */
.search-inputs {
    /* border: 1px solid #444444; */
    border-radius: 8px;
}

/* select options */

#search-selection {
    appearance: none;
    -webkit-appearance: none;
    background-color: rgb(234, 234, 234);
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%236B7280' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 0 center;
    cursor: pointer;
    padding: 12px 40px 12px 16px;
    border-radius: none;
}

#search-selection option:disabled {
    color: #9ca3af;
}

::v-deep(.ais-SearchBox-form) {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 4px;
    display: flex;
    height: 50px;
    border: 1px solid var(--gris-urbano) !important;
}

::v-deep(.ais-SearchBox-input) {
    flex: 1;
    border: none;
    outline: none;
    font-size: 14px;
    padding: 6px;
    font-family: 'Trebuchet MS';
    color: black;
}

::v-deep(.ais-SearchBox-submit) {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    font-size: 18px !important;
    margin: 0 8px;
    cursor: pointer;
}

::v-deep(.ais-SearchBox-submitIcon) {
    width: 18px;
    height: 18px;
    fill: #4cabd3 !important;
}

::v-deep(.ais-SearchBox-reset) {
    display: none;
}

::v-deep(.ais-SearchBox-resetIcon) {
    display: none;
}

.position-relative {
    position: relative;
}

.columns-container {
    display: flex;
}

.column-search {
    flex: 1;
    padding: 5px;
    margin-top: 1px;
    background-color: #f3f3f3;
    z-index: 100;
    /* border: 1px solid #e0e0e0; */
}

.hit-item {
    padding: 10px;
    border-bottom: 1px solid #eee;
    transition: background-color 0.2s;
}

.hit-item:hover {
    background-color: #f0f8ff;
    cursor: pointer;
}

.indicator {
    color: var(--celeste-electrico);
    font-family: 'Trebuchet MS';
    font-size: 12pt;
    margin-right: 6px;
    font-weight: bold;
}
.indicator-value {
    font-family: 'Trebuchet MS';
    font-size: 12pt;
}

.field-input {
    /* color: red; */
    color: var(--gris-urbano);
    font-family: 'Trebuchet MS';
}

.field-input :deep(.v-field-label) {
    opacity: 1 !important;
    transition: none !important;
}

.field-input :deep(.v-field__overlay) {
    opacity: 0 !important;
    background-color: transparent !important;
    transition: none !important;
}

.field-input :deep(.v-field__outline) {
    transition: none !important;
}

.field-input :deep(.v-field) {
    transition: none !important;
}

.field-input :deep(.v-field__outline),
.field-input :deep(.v-field__outline::before),
.field-input :deep(.v-field__outline::after) {
    opacity: 1 !important;
    border-color: #4cabd3 !important; /* tu color fijo */
    transition: none !important;
}

.field-label {
    color: var(--celeste-electrico);
    font-weight: bold;
    font-family: 'Trebuchet MS';
    font-size: 13pt;
}

.return-btn {
    margin-bottom: 15px;
    background-color: var(--verde-azulado-vibrante);
    font-family: var(--font-body);
    color: #fff;
    font-size: 18px;
    border: none;
    border-radius: 4px;
    padding: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 2px; /* Espacio entre flecha y texto */
    transition: background-color 0.3s ease;
}

.custom-field {
    position: relative;
    display: inline-block;
}

.custom-label {
    color: var(--celeste-electrico);
    font-weight: bold;
    font-family: 'Trebuchet MS';
    font-size: 13pt;
    position: absolute;
    top: -14px;
    left: 14px;
    background: white;
    padding: 0 4px;
}

.custom-box {
    color: #000000;
    border: 1px solid var(--gris-urbano);
    border-radius: 8px;
    padding: 12px;
    min-height: 100px;
}

::v-deep(.is-loading-cursor),
::v-deep(.is-loading-cursor *) {
    cursor: progress !important;
}
</style>
